import React, { useEffect, useState } from 'react'
import { ClockCircleOutlined } from '@ant-design/icons'
import { Order, PaymentMethod } from 'hooks/useCartCheckout'
import { QRCodeCanvas } from 'qrcode.react'
import { useHistory } from 'react-router-dom'
import useQueryString from 'hooks/useQueryString'
import LoadingContainer from 'components/LoadingContainer'
import { CountDown } from './CountDown'
import * as Style from './styles'

interface Props {
  order?: Order
  payment?: PaymentMethod
  generatePixInfo?: any
  pixInfo?: string
  finishOrderByPaymentMethod: any
  error: any
}

export function Pix({ finishOrderByPaymentMethod, error, loadingContainer }: any) {
  const [lineIsCopied, setLineIsCopied] = useState(false)
  const [, setCopyClipboard] = useState<string>('')
  const [pixInfo, setPixInfo] = useState<string>('')

  const { filters } = useQueryString()
  const cart_id = filters?.cart_id
  const history = useHistory()
  const [paymentStatus, setPaymentStatus] = useState('')

  const copyByClipboard = (text: string) => {
    const fallbackCopy = (t: string) => {
      try {
        const textarea = document.createElement('textarea')
        textarea.value = t
        textarea.style.cssText = 'position:fixed;top:-9999px;left:-9999px;opacity:0'
        document.body.appendChild(textarea)
        textarea.focus()
        textarea.select()
        document.execCommand('copy')
        document.body.removeChild(textarea)
      } catch {
        // sem suporte a cópia
      }
    }

    const onCopied = () => {
      setCopyClipboard(text)
      setLineIsCopied(true)
      setTimeout(() => setLineIsCopied(false), 3000)
    }

    if (navigator.clipboard?.writeText) {
      navigator.clipboard
        .writeText(text)
        .then(onCopied)
        .catch(() => {
          fallbackCopy(text)
          onCopied()
        })
    } else {
      fallbackCopy(text)
      onCopied()
    }
  }
  const handleFinishOrder = async () => {
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag('event', 'conversion', {
        allow_custom_scripts: true,
        send_to: 'DC-15596039/invmedia/canne005+standard'
      })
    }

    const data = await finishOrderByPaymentMethod({ type: 'pix' })
    setPixInfo(data?.paymentInfos?.pix_qr_code)
  }
  useEffect(() => {
    handleFinishOrder()
  }, [])

  return (
    <Style.Container>
      {loadingContainer && <LoadingContainer loading />}
      {!loadingContainer && (
        <>
          <Style.CountDownContainer>
            <ClockCircleOutlined style={{ fontSize: '24px', paddingRight: '10px' }} />
            <Style.CountDownContent>
              <CountDown generatePixInfo={finishOrderByPaymentMethod} payment={{ type: 'pix' }} />
              <p>para expirar</p>
            </Style.CountDownContent>
          </Style.CountDownContainer>
          <Style.QrCodeContainer>
            <QRCodeCanvas
              value={pixInfo}
              size={200}
              bgColor="#f6f6f6"
              fgColor="#000000"
              level="L"
              includeMargin={false}
            />
            <Style.QrCodeinfos>
              <p>1. Copia a chave pix.</p>
              <p>2. Entre no aplicativo da sua instituição financeira e acesse o ambiente pix.</p>
              <p>3. Escolha a opção de Copia e Cola e insira o código Pix.</p>
              <p>4. Verifique as informações e confirme o pagamento.</p>
              <p>
                5. Após validado o pagamento você será automaticamente direcionado para a página de resumo de compra.
              </p>
            </Style.QrCodeinfos>
          </Style.QrCodeContainer>
          {!lineIsCopied ? (
            <Style.ButtonCopy onClick={() => copyByClipboard(pixInfo)}> Copiar código </Style.ButtonCopy>
          ) : (
            <Style.ButtonCopied> Código copiado </Style.ButtonCopied>
          )}
        </>
      )}
    </Style.Container>
  )
}
